import {combineReducers} from 'redux-immutable';
import {connectRouter} from 'connected-react-router';

import login from './login';
import notifications from './notifications';
import user from './user';
import ui from './ui';
import companies from './companies';
import languages from './languages';
import testroom from './testroom';
import tests from './tests';
import userCampaign from './userCampaign';
import reports from './reports';
import samples from './samples';
import privacyAgreement from './privacyAgreement';
import fluxes from './fluxes';
import questionnaire360 from './questionnaire360';
import evaluationQuestions from './evaluationQuestions';

const reducers = {
  login,
  notifications,
  user,
  companies,
  languages,
  testroom,
  tests,
  userCampaign,
  reports,
  samples,
  privacyAgreement,
  ui,
  fluxes,
  questionnaire360,
  evaluationQuestions,
};

export default history => combineReducers({...reducers, router: connectRouter(history)});
